import {Component, OnInit, OnDestroy, Input} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {NgbActiveModal, NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Phone, IPhone} from '../../shared/model/phone.model';
import {PhoneService} from './phone.service';
import {HttpErrorResponse, HttpHeaders, HttpResponse} from '@angular/common/http';
import {NgxSpinnerService} from 'ngx-spinner';
import {Observable} from 'rxjs/Rx';

// import { JhiEventManager } from 'ng-jhipster';


@Component({
  selector: 'app-search-dialog',
  templateUrl: './phone-search.component.html'
})
export class PhoneSearchComponent implements OnInit {
  phone: IPhone = new Phone();
  phones: IPhone[];

  @Input() phoneEdit;
  public serverValidationError = false;

  constructor(protected phoneService: PhoneService,
              public activeModal: NgbActiveModal,
              private spinner: NgxSpinnerService, private router: Router,
              // protected eventManager: JhiEventManager
  ) {
  }

  ngOnInit() {
    // alert(' in id===' + this.phoneEdit);
    // alert(' in init ==' + this.phoneEdit);
    if (this.phoneEdit) {

      this.phoneService.find(this.phoneEdit).subscribe(
        (res: HttpResponse<IPhone>) => {
          this.phone = res.body;
          // alert(this.phone);
        },
        // (res: HttpErrorResponse) => this.onError(res.message)
      );
    }
  }

  onKeyUpChangePhoneNumber(val) {
    this.serverValidationError = false;
    if (val) {
      this.phone.jhiNumber = val;
    }
    // this.subscribeToSaveResponse3(
    //   this.phoneService.createValidationNumber(this.phone));

    // if (this.phone.id !== undefined) {
    this.subscribeToSaveResponse4(this.phoneService.createValidationNumber(this.phone));
    // }
  }

  processError(response) {
    if (response.status === 400) {
      this.serverValidationError = true;
    }
  }

  protected subscribeToSaveResponse4(result: Observable<HttpResponse<IPhone>>) {
    result.subscribe((res: HttpResponse<IPhone>) => this.onSaveSuccess(), (res: HttpErrorResponse) => this.processError(res));
  }

  protected onSaveSuccess() {
    // this.isSaving = false;
    this.activeModal.dismiss('cancel');
    // this.toastr.success('     ثبت با موفقیت انجام شد.      ', '   کاربر گرامی!    ');

    // this.previousState();
  }

  protected onSaveError() {
    // this.isSaving = false;
  }


  goToProfile(id) {
    this.router.navigate(['/page/profile-customer/' + id]);
    this.clear();
  }

  nextToAdd() {
    this.router.navigate(['/page/profile-customer/new/'+this.phone.jhiNumber ]);
    this.clear();

  }
  search(page) {
    this.spinner.show();
    // if(page) {
    //   this.page=page;
    // } else {
    //   this.page = 1;
    //
    // }    // alert(' in search ');
    const employeeId = 1;

    // this.accountService.identity().then(account => {
    // alert(' in account ==' + account.id);
    const number = (this.phone.jhiNumber ? this.phone.jhiNumber : '');
    // const audience = (this.phone.audience ? this.phone.audience : '');
    // const position = (this.phone.position ? this.phone.position : '');
    // const customer = (this.phone.status ? this.phone.status : '');
    // const type = (this.phone.jhiType ? this.phone.jhiType : '');
    // const temp = 'd';
    // const customer = this.phone.customer.title;

    // this.account = account;

    // alert(' employeeId== ' + employeeId);
    this.phoneService
      .search({
        page: 0,
        size: 20,
        sort: this.sort(),
        // temp,
        // audience,
        number
        // type,
        // position,
        // customer
      })
      .subscribe(
        (res: HttpResponse<IPhone[]>) => this.paginatePhones(res.body, res.headers),
        (res: HttpErrorResponse) => this.onError(res.message)
      );
    // });
  }

  protected paginatePhones(data: IPhone[], headers: HttpHeaders) {
    // this.links = this.parseLinks.parse(headers.get('link'));
    // this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
    // this.queryCount = this.totalItems;
    this.phones = data;
    this.spinner.hide();

  }

  sort() {
    const result = ['audience, asc'];
    return result;
  }

  protected onError(errorMessage: string) {
    // this.jhiAlertService.error(errorMessage, null, null);
  }


  clear() {
    this.activeModal.dismiss('cancel');
  }

  confirmDelete(id: number) {
    this.phoneService.delete(id).subscribe(response => {
      // this.eventManager.broadcast({
      //     name: 'phoneListModification',
      //     content: 'Deleted an phone'
      // });
      this.activeModal.dismiss(true);
    });
  }
}
